document.querySelectorAll('li.main-key-feature-card__list-item').forEach(el => {
  el.addEventListener('mouseenter', e => e.stopImmediatePropagation(), true);
  el.addEventListener('mouseover', e => e.stopImmediatePropagation(), true);
});

// MUSLIMFY: Force first AI-generated image on product page load
// Prevents variant swatch image from showing as the initial gallery slide
(function () {
  function getVariantMediaIds() {
    var ids = new Set();
    // Primary: data-variant-media-ids attribute injected by Liquid in _product-gallery.liquid
    var galleryEl = document.querySelector('media-gallery');
    var raw = galleryEl && galleryEl.getAttribute('data-variant-media-ids');
    if (raw) {
      raw.split(',').forEach(function (id) { if (id.trim()) ids.add(id.trim()); });
      return ids;
    }
    // Fallback: window.cjpod.product (CJ Pod app, may not be present)
    var p = window.cjpod && window.cjpod.product;
    if (p && p.variants) {
      p.variants.forEach(function (v) {
        if (v.featured_media && v.featured_media.id) ids.add(String(v.featured_media.id));
      });
    }
    return ids;
  }

  function forceAIImageFirst() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var activeSlide = viewer.querySelector('.slider__slide.is-active');
    if (!activeSlide) return;

    var activeMediaId = activeSlide.getAttribute('data-media-id');
    if (!activeMediaId) return;

    // Strategy 1: marked with muslimfy-variant-media class (post-ZIP-rebuild)
    var isVariant = activeSlide.classList.contains('muslimfy-variant-media');

    // Strategy 2: cross-reference against product variant featured_media IDs
    var variantIds = getVariantMediaIds();
    if (!isVariant && variantIds.size > 0) {
      // data-media-id = "sectionId-mediaId" — take the last segment
      var parts = activeMediaId.split('-');
      var numericId = parts[parts.length - 1];
      isVariant = variantIds.has(numericId);
    }

    if (!isVariant) return; // Active image is already an AI image

    // Find the first slide that is NOT a variant image
    var allSlides = viewer.querySelectorAll('.slider__slide[data-media-id]');
    var targetSlide = null;
    for (var i = 0; i < allSlides.length; i++) {
      var slide = allSlides[i];
      if (slide.classList.contains('muslimfy-variant-media')) continue;
      var sid = (slide.getAttribute('data-media-id') || '').split('-');
      var snum = sid[sid.length - 1];
      if (variantIds.size > 0 && variantIds.has(snum)) continue;
      targetSlide = slide;
      break;
    }

    if (!targetSlide) return;

    var targetId = targetSlide.getAttribute('data-media-id');
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(targetId, false);
    } else {
      viewer.querySelectorAll('.slider__slide').forEach(function (s) {
        s.classList.remove('is-active');
      });
      targetSlide.classList.add('is-active');
    }
  }

  function runWhenReady() {
    if (customElements.get('media-gallery')) {
      requestAnimationFrame(function () { requestAnimationFrame(forceAIImageFirst); });
    } else {
      customElements.whenDefined('media-gallery').then(function () {
        requestAnimationFrame(function () { requestAnimationFrame(forceAIImageFirst); });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenReady);
  } else {
    runWhenReady();
  }
})();